import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export function useDeleteResponse(testId?: string) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const deleteResponse = useMutation({
    mutationFn: async (responseId: string) => {
      const { error } = await supabase.rpc('delete_test_response', { 
        p_response_id: responseId 
      });
      if (error) throw error;
    },
    onSuccess: (_data, responseId) => {
      toast({
        title: 'Response deleted',
        description: 'The candidate response has been removed.',
      });
      if (testId) {
        queryClient.invalidateQueries({ queryKey: ['test-responses', testId] });
        queryClient.invalidateQueries({ queryKey: ['test-response-stats', testId] });
      }
      queryClient.invalidateQueries({ queryKey: ['test-response', responseId] });
    },
    onError: (error: any) => {
      toast({
        title: 'Delete failed',
        description: error?.message || 'Could not delete the response.',
        variant: 'destructive',
      });
    },
  });

  return { deleteResponse, isDeleting: deleteResponse.isPending };
}